package com.milta.core.localization.translations.fr

import com.milta.core.localization.WebImportRouteStrings

internal val WebImportRoute = WebImportRouteStrings(
    headerSubtitle = "Import d'un fichier de livraisons et assignation à un livreur",
    stepImport = "Importer",
    stepVerifyAssign = "Vérifier & assigner",
    stepValidateSend = "Valider et envoyer les tournées",
    dropzoneTitle = "Glissez-déposez votre fichier de livraisons",
    dropzoneOrPrefix = "ou",
    browseFilesLink = "parcourez vos fichiers",
    browseFilesButton = "Parcourir les fichiers",
    constraintsLabel = "Excel (.xlsx, .xls) ou CSV · 500 arrêts max · 10 Mo",
    expectedColumnsEyebrow = "Colonnes attendues dans le fichier",
    columnRecipientName = "Nom du destinataire",
    columnAddress = "Adresse complète",
    columnDeadline = "Heure limite",
    columnPhone = "Téléphone",
    requiredPillLabel = "Requis",
    optionalPillLabel = "Optionnel",
    analysingLabel = "Analyse en cours…",
    invalidFileTitle = "Fichier illisible ou format non pris en charge",
    invalidFileMessage = "« %s » n'a pas pu être analysé. Utilisez un fichier Excel (.xlsx, .xls) ou CSV respectant les colonnes attendues.",
    chooseAnotherFileButton = "Choisir un autre fichier",
    extractionFailedTitle = "Impossible d'extraire les livraisons",
    extractionFailedMessage = "Le fichier « %s » a été lu mais aucune ligne exploitable n'a été trouvée. Vérifiez qu'il contient bien les colonnes attendues.",
    serviceUnavailableTitle = "Service d'analyse temporairement indisponible",
    serviceUnavailableMessage = "Nous n'arrivons pas à analyser votre fichier pour le moment. Réessayez dans quelques instants.",
    retryButton = "Réessayer",
    fileImportedStatus = "Fichier importé",
    stopsDetectedSuffix = "arrêts détectés",
    replaceFileLink = "↺ Remplacer",
    assignToEyebrow = "Assigner à",
    selectDriverRequiredError = "Veuillez sélectionner au moins un chauffeur avant d'envoyer la tournée.",
    selectedDriversCountSuffix = "chauffeurs sélectionnés",
    optimizeRouteButton = "Optimiser l'itinéraire",
    tableCaptionLead = "Vérifiez et corrigez les arrêts avant d'envoyer",
    tableCaptionHint = "Cliquez sur le crayon pour corriger une ligne",
    columnHeaderIndex = "#",
    columnHeaderRecipientName = "Nom destinataire",
    columnHeaderAddress = "Adresse",
    columnHeaderPhone = "Téléphone",
    columnHeaderDeadline = "Heure limite",
    dashPlaceholder = "—",
    freeFormatBanner = "Format libre détecté — les colonnes n'ont pas pu être reconnues automatiquement, vérifiez chaque ligne avant d'envoyer.",
    incompleteStopsBannerSuffix = "arrêts incomplets — nom ou adresse manquant, à corriger avant l'envoi.",
    rowFlagMissingName = "⚠ nom manquant",
    rowFlagMissingAddress = "⚠ adresse manquante",
    alreadyDispatchedBanner = "Cette tournée a déjà été envoyée à un chauffeur — actualisez la page pour repartir d'un nouvel import.",
    routeNotFoundError = "Tournée introuvable. Actualisez la page et réessayez.",
    validationErrorGeneric = "Veuillez vérifier les informations saisies.",
    submitServerError = "Une erreur est survenue. Réessayez.",
    submitOptimizationUnavailableError = "Service d'optimisation temporairement indisponible. La tournée n'a pas été créée — réessayez dans quelques instants.",
    sendWithoutOptimizationButton = "Envoyer sans optimisation",
    dispatchSuccessMessage = "Tournée envoyée avec succès à %s",
    dispatchSuccessBatchMessage = "Tournées envoyées avec succès à %d chauffeurs",
    tooManyStopsError = "Ce fichier contient plus de 500 livraisons. Merci de le diviser avant de l'importer.",
    resultHeaderMiddle = "livraisons réparties entre",
    resultDriverSingularSuffix = "chauffeur",
    resultDriverPluralSuffix = "chauffeurs",
    resultDistanceLabel = "Distance",
    resultDurationLabel = "Durée estimée",
    resultMetricNotCalculatedLabel = "Non calculée",
    resultStopsChipSuffix = "arrêts",
    resultMoreStopsTemplate = "+ %d autres arrêts",
    resultStopsLoadError = "Impossible de charger les arrêts de cette tournée.",
    resultDispatchButton = "Valider et envoyer les tournées",
)
